import { Form } from "antd";
import { useEffect } from "react";
import { FormModal } from "@/shared/components/FormModal";
import { useCreateEquipmentType, useUpdateEquipmentType } from "../hooks/useEquipmentTypes";
import { useEquipmentTypesStore } from "../store/equipment-types.store";
import type { CreateEquipmentTypeRequest } from "../types";
import { EquipmentTypeForm } from "./EquipmentTypeForm";

type FormValues = {
	name: string;
	color?: string;
	icon?: string[];
	description?: string;
};

export function EquipmentTypeFormModal() {
	const [form] = Form.useForm<FormValues>();
	const { modalOpen, editingItem, closeModal } = useEquipmentTypesStore();

	const { mutate: create, isPending: isCreating } = useCreateEquipmentType();
	const { mutate: update, isPending: isUpdating } = useUpdateEquipmentType();

	const close = () => {
		form.resetFields();
		closeModal();
	};

	useEffect(() => {
		if (modalOpen) {
			if (editingItem) {
				form.setFieldsValue({
					name: editingItem.name,
					color: editingItem.color ?? undefined,
					icon: editingItem.icon ?? undefined,
					description: editingItem.description ?? undefined,
				});
			} else {
				form.resetFields();
			}
		}
	}, [modalOpen, editingItem, form]);

	const onFinish = (values: FormValues) => {
		const data: CreateEquipmentTypeRequest = {
			name: values.name,
			color: values.color ?? null,
			icon: values.icon,
			description: values.description ?? null,
		};

		if (editingItem) {
			update({ id: editingItem.id, data }, { onSuccess: close });
		} else {
			create(data, { onSuccess: close });
		}
	};

	const initialIconUrl =
		editingItem?.icon && editingItem.icon.length > 0 ? editingItem.icon[0] : null;

	return (
		<FormModal
			title="Yangi texnika turi"
			editTitle="Texnika turini tahrirlash"
			editing={!!editingItem}
			open={modalOpen}
			onCancel={close}
			onOk={form.submit}
			confirmLoading={isCreating || isUpdating}
			width={520}
		>
			<Form form={form} layout="vertical" requiredMark={false} onFinish={onFinish}>
				<EquipmentTypeForm initialIconUrl={initialIconUrl} />
			</Form>
		</FormModal>
	);
}
